import './frontend.scss';

const carouselBlocks = document.querySelectorAll('.wp-block-itp-carousel');

/**
 * Set a carousel content block size custom property.
 *
 * @param {Element} carousel The carousel element.
 *
 * @return {void}
 */
const determineCarouselContentBlockSize = (carousel) => {
  const carouselContentBox = carousel.querySelector('.wp-block-itp-carousel-content');

  if (!carouselContentBox) {
    return;
  }

  const carouselContentBoxHeight = `${carouselContentBox.offsetHeight}px`;
  carousel.style.setProperty('--carousel-content-block-size', carouselContentBoxHeight);
};

/**
 * Debounce function.
 *
 * @param {Function} func The function to run.
 * @param {number}   wait The debounce time.
 *
 * @return {Function} The debounced function.
 */
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

const browserResizeHandler = debounce(() => {
  carouselBlocks.forEach((carousel) => {
    determineCarouselContentBlockSize(carousel);
  });
}, 100);

window.addEventListener('resize', browserResizeHandler);
window.addEventListener('load', browserResizeHandler);
